import React from "react";
import TeamCard, { CoachTeam } from "./TeamCard";

interface MyTeamsGridProps {
  teams: CoachTeam[];
  loading?: boolean;
}

const TeamCardSkeleton: React.FC = () => (
  <div
    className="bg-white rounded-2xl p-5 animate-pulse"
    style={{ boxShadow: "0 2px 14px rgba(0,0,0,0.07)" }}
  >
    <div className="flex justify-between mb-4">
      <div className="h-5 bg-gray-100 rounded w-32" />
      <div className="h-7 bg-gray-100 rounded-lg w-24" />
    </div>
    <div className="h-3 bg-gray-100 rounded w-40 mb-4" />
    <div className="flex items-center justify-between mb-3">
      <div className="flex -space-x-2">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="w-8 h-8 rounded-full bg-gray-100 border-2 border-white"
          />
        ))}
      </div>
      <div className="h-5 w-10 bg-gray-100 rounded" />
    </div>
    <div className="h-1.5 bg-gray-100 rounded-full mb-4" />
    <div className="h-9 bg-gray-100 rounded-lg" />
  </div>
);

const MyTeamsGrid: React.FC<MyTeamsGridProps> = ({ teams, loading }) => {
  return (
    <section>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-[18px] font-bold text-[#26295e] font-primary">
          My Teams
        </h2>
        <span
          className="text-[12px] font-semibold px-3 py-1 rounded-full font-primary"
          style={{
            background: "rgba(0,103,255,0.08)",
            color: "#0067ff",
          }}
        >
          {loading ? "..." : `${teams.length} teams`}
        </span>
      </div>

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <TeamCardSkeleton key={i} />
          ))}
        </div>
      ) : teams.length === 0 ? (
        <div
          className="bg-white rounded-2xl p-10 text-center"
          style={{ boxShadow: "0 2px 14px rgba(0,0,0,0.06)" }}
        >
          <div className="w-14 h-14 rounded-2xl bg-[#f0f3fa] flex items-center justify-center mx-auto mb-3">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#9ba5b4"
              strokeWidth="1.5"
            >
              <rect x="3" y="3" width="7" height="7" rx="1" />
              <rect x="14" y="3" width="7" height="7" rx="1" />
              <rect x="3" y="14" width="7" height="7" rx="1" />
              <rect x="14" y="14" width="7" height="7" rx="1" />
            </svg>
          </div>
          <p className="text-[14px] font-semibold text-[#26295e] font-primary mb-1">
            No teams yet
          </p>
          <p className="text-[12px] text-[#9ba5b4] font-primary">
            Teams you coach will appear here
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {teams.map((team) => (
            <TeamCard key={team.id} team={team} />
          ))}
        </div>
      )}
    </section>
  );
};

export default MyTeamsGrid;
